/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { icons } from '../../../assets';

export const getOrderStatusIcon = (statusId: number): string => {
    switch (statusId) {
        case 150080001:
            return icons.processStatusIcon;
        case 150080000:
            return icons.waiting;
        case 150080006:
            return icons.errorStatusIcon;
        case 150080009:
            return icons.halfStatusIcon;
        case 150080005:
            return icons.doneStatusIcon;
        default:
            return '';
    }
};
